<div class="min-h-screen mx-auto px-4 flex flex-col"
     *ngIf="config"
     [class.max-w-5xl]="config.screenRatio < 1"
     [class.max-w-xl]="config.screenRatio >= 1"
     [class.completed]="job && job.status == 'completed'"
>

  <div id="logo-wrapper">
    <img [src]="getLogoUrl()" alt="Logo">
  </div>

  <content-block class="md:w-2/3 md:mx-auto" [slug]="'default-result-top'" id="default-result-top-wrapper" [class.hidden]="boothMode"></content-block>
  <content-block class="md:w-2/3 md:mx-auto" [slug]="'wbm-result-top'" id="wbm-result-top-wrapper" [class.hidden]=" ! boothMode"></content-block>

  <div class="relative w-full" *ngIf="! boothMode && job && ! hasMoreThanOneOutputAsset(job) && job.status == 'completed'">
    <div class="relative overflow-hidden rounded-lg aspect-square">
      <ng-container *ngFor="let asset of job.assets">
        <ng-container *ngIf="asset.assetType == 'output'">
          <ng-container *ngIf="asset.contentType == 'image/jpeg'">
            <img [src]="asset.url" class="absolute block aspect-square object-contain min-h-full" alt="AI Generated Image">
          </ng-container>
          <ng-container *ngIf="asset.contentType == 'video/h264-mp4'">
            <video autoplay loop muted playsinline class="absolute block aspect-square object-contain ios-downloadable h-full w-full">
              <source [src]="asset.url" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <div #carousel class="relative w-full" *ngIf="! boothMode && job && hasMoreThanOneOutputAsset(job) && job.status == 'completed'">
    <!-- Carousel wrapper -->
    <div class="relative overflow-hidden rounded-lg aspect-square">
      <ng-container *ngFor="let asset of job.assets">
        <ng-container *ngIf="asset.assetType == 'output'">
          <ng-container *ngIf="asset.contentType == 'image/jpeg'">
            <div class="carousel-item hidden duration-700 ease-in-out" #item>
              <img [src]="asset.url" [default]="defaultImageUrl" class="absolute block aspect-square object-contain ios-downloadable h-full w-full" alt="AI Generated Image">
            </div>
          </ng-container>
          <ng-container *ngIf="asset.contentType == 'video/h264-mp4'">
            <div class="carousel-item hidden duration-700 ease-in-out" #item>
              <video autoplay loop muted playsinline class="absolute block aspect-square object-contain ios-downloadable h-full w-full">
                <source [src]="asset.url" type="video/mp4">
                Your browser does not support the video tag.
              </video>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
    <!-- Slider indicators -->
    <div class="carousel-indicators absolute z-30 flex -translate-x-1/2 left-1/2 space-x-3 rtl:space-x-reverse">
      <ng-container *ngFor="let asset of job.assets; index as i">
        <ng-container *ngIf="asset.assetType == 'output'">
          <button type="button" class="w-3 h-3 rounded-full" #indicator></button>
        </ng-container>
      </ng-container>
    </div>
    <!-- Slider controls -->
    <button type="button" class="absolute top-0 start-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none" (click)="prev()">
      <span class="inline-flex items-center justify-center w-10 h-10 rounded-full slider-wrapper">
          <svg class="w-4 h-4 rtl:rotate-180 slider-button" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 1 1 5l4 4"/>
          </svg>
          <span class="sr-only">Previous</span>
      </span>
    </button>
    <button type="button" class="absolute top-0 end-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none" (click)="next()">
      <span class="inline-flex items-center justify-center w-10 h-10 rounded-full slider-wrapper">
          <svg class="w-4 h-4 slider-button rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
          </svg>
          <span class="sr-only">Next</span>
      </span>
    </button>
  </div>

  <content-block [slug]="'default-result-bottom'" id="default-result-bottom-wrapper" [class.hidden]="boothMode" *ngIf="job && job.status == 'completed'"></content-block>
  <content-block [slug]="'wbm-result-bottom'" id="wbm-result-bottom" [class.hidden]=" ! boothMode"></content-block>

  <div class="flex flex-row py-6 items-center justify-around" *ngIf="! boothMode && job && job.status == 'completed'">

    <div class="flex flex-col text-center" *ngIf="sharingAvailable && config.enableShare">
      <button
        type="button"
        class="button-primary"
        (click)="share()"
      >
        <fa-icon [icon]="faShareNodes"></fa-icon>
      </button>
      <span id="share-button" i18n>Share</span>
    </div>
    <div class="flex flex-col text-center" *ngIf="!disableDownload && config.enableDownload">
      <button
        type="button"
        class="button-primary"
        (click)="download()"
      >
        <fa-icon [icon]="faDownload"></fa-icon>
      </button>
      <span id="download-button" i18n>Download</span>
    </div>
  </div>

  <div *ngIf="! boothMode && job && isValidJobStatus(job.status)" class="md:w-2/3 md:mx-auto">
    <snapmatic-progress [status]="job.status" [position]="job.position"></snapmatic-progress>
  </div>

  <div *ngIf="! boothMode && job && isError(job.status)" class="md:w-2/3 md:mx-auto">
    <div class="text-center text-error-color text-lg my-6">
      <h1>{{ job.status.replace('_',' ') }}</h1>
      <p i18n>There was an error processing your AI image.</p>
      <p i18n>Please refresh this page. If the problem persist, please try again.</p>
    </div>
  </div>

  <div class="aspect-square md:w-2/3 md:mx-auto py-6" *ngIf="( ! isMobile && config.enableQr) || (boothMode && config.enableQr)">
    <img [src]="getQRCode()" alt="QR Code" class="border-[2rem] border-white rounded-xl">
  </div>

  <div class="flex items-center justify-center md:w-2/3 md:mx-auto" *ngIf="boothMode">
    <button type="button" id="finish-button" class="button-primary my-3" routerLink="../../home" i18n>Finish</button>
  </div>

  <content-block [slug]="'default-disclaimer-bottom'" id="default-disclaimer-bottom-wrapper" [class.hidden]="boothMode"></content-block>
  <content-block [slug]="'wbm-disclaimer-bottom'" id="wbm-disclaimer-bottom-wrapper" [class.hidden]=" ! boothMode"></content-block>

</div>
